import { Injectable } from '@angular/core';
import { EconomicActivityModal } from '../../domain/actividad-economica-modal';
import { map, Observable } from 'rxjs';

import {
  API_CONFIG,
  BaseCrudService,
  buildSearchByTerm,
  PageResponse,
} from '@nebula-shared/data-access';

import { ApiResponse } from '@nebula-shared/domain';
@Injectable({
  providedIn: 'root',
})
export class EconomicActivityService extends BaseCrudService<EconomicActivityModal> {
  constructor() {
    super();
    const config = API_CONFIG.accounting;
    this.setBaseUrl(`${config.baseUrl}${config.endpoints.actividadEconomica}`);
  }

  getAllEconomicActivities(
    page: number,
    size: number,
    searchTerm?: string,
    sortColumn?: string,
    sortDirection: 'ASC' | 'DESC' = 'ASC',
  ): Observable<PageResponse<EconomicActivityModal>> {
    const searchsBy = [
      {
        key: 'status',
        operation: 'MATCH',
        value: 'ACTIVE',
      },
      ...buildSearchByTerm(searchTerm, [
        { key: 'codigo', type: 'text' },
        { key: 'descripcion', type: 'text' },
      ]),
    ];

    const ordersBy: { column: string; direction: 'ASC' | 'DESC' }[] = [];
    if (sortColumn) {
      ordersBy.push({ column: sortColumn, direction: sortDirection });
    }

    const body = {
      page: page.toString(),
      size: size.toString(),
      ...(searchsBy.length > 0 && { searchsBy }),
      ...(ordersBy.length > 0 && { ordersBy }),
    };

    return this.getPageResponse(page, size, body).pipe(
      map((response: ApiResponse<PageResponse<EconomicActivityModal>>) => {
        const envelope = response?.response || response;
        const pageData = envelope?.content || envelope || {};

        return {
          size: pageData.size || size,
          number: pageData.number || page,
          numberOfElements: pageData.numberOfElements || pageData.content?.length || 0,
          totalElements: pageData.totalElements || 0,
          totalPages: pageData.totalPages || 0,
          content: pageData.content || [],
          empty: !pageData.content || pageData.content.length === 0,
        };
      }),
    );
  }
}
